import type { Member } from '@hero/schema';
import { useTranslation } from 'react-i18next';
import { DrawerContentList } from '../../../app/Drawer/DrawerContentList';
import { DrawerContentCard } from '../../../app/Drawer/DrawerContentCard';
import { MemberTypeBadge } from '../Status/MemberTypeBadge';

export interface MemberSummaryTabProps {
  member: Member;
}

export function MemberSummaryTab({ member }: MemberSummaryTabProps) {
  const { t } = useTranslation(['m-member', 'c-nationalities']);

  const isDriver = member.type === 'driver';

  return (
    <div className="flex flex-col gap-4 p-5">
      <DrawerContentCard
        title={t('drawer.tabs.summary')}
        list={[
          { label: t('drawer.fields.name'), value: member.name || '-' },
          { label: t('drawer.fields.phone'), value: member.phone || '-' },
          { label: t('drawer.fields.email'), value: member.email || '-' },
          {
            label: t('drawer.fields.type'),
            value: <MemberTypeBadge type={member.type} />,
          },
        ]}
      />

      {isDriver && member.driver && (
        <DrawerContentCard
          title={t('drawer.tabs.driver_details')}
          list={[
            {
              label: t('drawer.driver_id'),
              value: member.driver.id || '-',
            },
            {
              label: t('c-nationalities:nationality'),
              value: member.driver.nationality || '-',
            },
          ]}
        />
      )}
    </div>
  );
}
